// extracted by mini-css-extract-plugin
module.exports = {"uppercase":"Waiting_uppercase__2Gp2S","price":"Waiting_price__39ujv"};